export const abbreviations = {
    English: 'en',
    Spanish: 'es'
};

// To-do: revisit this, current implementation only allows for two languages
export function getAltLanguage(currentLanguage) {
    const availableLanguages = Object.keys(abbreviations);
    const altLanguage = availableLanguages.find(language => language !== currentLanguage);

    return altLanguage;
}


export function getAbbreviation(language) {
    const abbreviation = abbreviations[language];

    return abbreviation ? abbreviation : `Abbreviation not found for value ${language}`;
}